// removed by extract-text-webpack-plugin
module.exports = {"playground":"usMgz","sidebar":"_20luu","contentWrapper":"_2aD31","content":"ovVRE","contentTitle":"_2MqIo","sidebarHeader":"fD2SK","sidebarNavItems":"bW-_5","current":"_1oshD","logo":"_2VJ8t","logoWord":"_1Gl6b","propToggle":"_1OcXc","propType":"_7Uk1C","propTypeHeader":"_2VMSX","propName":"_3EvKS","kind":"_3X9Ay","propTypeDescription":"_2ErGl","defaultValue":"_2Q3co","allowedValues":"_s_NB","allowedValuesLabel":"_13-0L"};


//////////////////
// WEBPACK FOOTER
// ./src/Playground.css
// module id = 546
// module chunks = 0